import styled from 'styled-components';
import * as Comp from './components/PageLayout';

export const PageLayout = styled(Comp.PageLayout)``;
export interface PageLayoutProps extends Comp.PageLayoutProps {}
